import { render } from "./index.vue?vue&type=template&id=27cc7e3b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=27cc7e3b&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__